import React, { useContext } from "react"
import * as styles from "./delivery.module.css"
import Card from "src/components/core/atoms/card"
import Button from "src/components/core/atoms/button"
import { ModalContext } from "src/context/ModalContext"

const InfoDelivery = () => {
  const { openModal } = useContext(ModalContext)

  const map = {
    variant: "mapping",
    isDefault: true,
  }

  const date = {
    variant: "date & time",
    isDefault: true,
  }

  return (
    <div className={styles.infoDelivery}>
      <Card title="Location Details">
        <p>
          Already know the location details? Feel free to add to your order and
          make adjustments to individual services if necessary.
        </p>
        <Button onClick={() => openModal(map)} variant="solid">
          Add Location
        </Button>
      </Card>
      <Card title="Date &amp; Time">
        <p>
          * Date and time can be amended at a later date, but please note a fee
          is incurred if cancelled under 24hrs from delivery.
        </p>
        <Button onClick={() => openModal(date)} variant="solid">
          Add Timings
        </Button>
      </Card>
    </div>
  )
}

export default InfoDelivery
